export const queryKeys = {
  users: {
    current: () => ["users", "current"] as const,
    byId: (id: string) => ["users", "byId", id] as const,
    list: (params?: Record<string, unknown>) =>
      ["users", "list", params] as const,
    tags: (userId?: string) => ["users", "tags", userId] as const,
  },

  sites: {
    byId: (id: number | string) => ["sites", "byId", id] as const,
    list: () => ["sites", "list"] as const,
  },

  payments: {
    kpi: (params?: unknown) => ["payments", "kpi", params] as const,
    telecollections: (params?: Record<string, unknown>) =>
      ["payments", "telecollections", params] as const,
    missingCardPayments: (params?: Record<string, unknown>) =>
      ["payments", "missing-card-payments", params] as const,
    nationalTransfers: (params?: Record<string, unknown>) =>
      ["payments", "national-transfers", params] as const,
    imports: (params?: Record<string, unknown>) =>
      ["payments", "imports", params] as const,
    import: (id: string) => ["payments", "imports", "detail", id] as const,
    domas: (subsidiaryId: string | null) =>
      ["payments", "domas", subsidiaryId] as const,
    bankAccounts: (subsidiaryId: string | null) =>
      ["payments", "bank-accounts", subsidiaryId] as const,
  },

  custom: (keyParts: readonly (string | number | undefined)[]) =>
    keyParts.filter(Boolean) as (string | number)[],
} as const;

export const cacheConfig = {
  static: {
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  },

  dynamic: {
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
  },

  realtime: {
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 2 * 60 * 1000,
  },

  critical: {
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  },
} as const;
